import axios from "axios";
import constants from "../../constants";

export default {
  async fetchCasts({ commit }, payload) {
    try {
      let resObj = await axios.get(
        `${constants.castUrl}/get/gb/casts/?email=${payload.email}&board_id=${payload.boardId}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
  async fetchRooms({ commit }, payload) {
    try {
      let resObj = await axios.get(
        `${constants.roomUrl}/get/gb/rooms/?email=${payload.email}&board_id=${payload.boardId}`
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },

  async joinCastByCreator({ commit }, payload) {
    let data = new FormData();
    data.append("cast_id", payload.publicMeetingId);
    data.append("passkey", payload.passkey);
    data.append("name", "");

    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    try {
      let resObj = await axios.post(
        `${constants.castUrl}/join/gb/cast/`,
        data,
        config
      );
      return resObj.data;
    } catch (error) {
      throw error;
    }
  },
};
